import { Primitive } from '@radix-ui/react-primitive';
import { type ComponentPropsWithoutRef, forwardRef, memo } from 'react';

import { tailwindVariants, type VariantProps } from '@air/utils-tailwind';

export const workspaceSidebarNavigationItem = tailwindVariants({
  base: 'flex items-center gap-2 truncate rounded-8 bg-transparent px-2 text-left text-14 font-normal text-grey-11 no-underline outline-none transition-colors data-[selected=true]:bg-grey-5 hover:bg-grey-5 hover:no-underline focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-blue-9 active:bg-grey-5',
  variants: {
    size: {
      small: 'h-6',
      medium: 'h-8',
      large: 'h-10',
    },
  },
  defaultVariants: {
    size: 'medium',
  },
});

export type WorkspaceSidebarNavigationItemVariants = VariantProps<typeof workspaceSidebarNavigationItem>;

export type WorkspaceSidebarNavigationItemProps = ComponentPropsWithoutRef<typeof Primitive.button> &
  WorkspaceSidebarNavigationItemVariants;

export const WorkspaceSidebarNavigationItem = memo(
  forwardRef<HTMLButtonElement, WorkspaceSidebarNavigationItemProps>(({ className, size, ...restOfProps }, ref) => {
    return (
      <Primitive.button ref={ref} className={workspaceSidebarNavigationItem({ size, className })} {...restOfProps} />
    );
  }),
);

WorkspaceSidebarNavigationItem.displayName = 'WorkspaceSidebarNavigationItem';
